import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M22 9l-10 -4l-10 4l10 4l10 -4v6","key":"svg-0"}],["path",{"d":"M6 10.6v5.4a6 3 0 0 0 12 0v-5.4","key":"svg-1"}]]

/**
 * IconSchool
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc2Nob29sIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0yMiA5bC0xMCAtNGwtMTAgNGwxMCA0bDEwIC00djYiIC8+CiAgPHBhdGggZD0iTTYgMTAuNnY1LjRhNiAzIDAgMCAwIDEyIDB2LTUuNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/school
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSchool = createReactComponent('outline', 'school', 'School', __iconNode);

export default IconSchool;